import cookie from 'react-cookies';
import jwtDecode from 'jwt-decode';
import _has from 'lodash/has';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill(); // Polyfill for smooth scrolling, required for older browsers such as Chrome 51

export function scrollToListing() {
  window.scrollTo({
    top: 500,
    behavior: 'smooth',
  });
}

export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

export function scrollToPlanFaq() {
  window.scrollTo({
    top: 2180,
    behavior: 'smooth',
  });
}

export function scrollToChoosePlan() {
  window.scrollTo({
    top: 550,
    behavior: 'smooth',
  });
}

export function htmlDecode(input) {
  let e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
}

export function redirectToLogin() {
  window.location = `${process.env.LOGOUT_URL}&signin=1&goto_url=${encodeURIComponent(window.location.href)}`;
}

export function redirectToProfile() {
  window.location = `${process.env.SITE_2_URL}/store/main/0?ca=9_s&sp=2`;
}

export function handleSessionChanged() {
  const msg = confirm('Session changed. Press OK to quit or Cancel to stay.');
  if (msg) {
    window.location = process.env.SITE_URL;
  }
}

export function listenForUnreadChatMessageCount(token, user_id, callback) {
  const io = require('socket.io-client');
  const socket = io(process.env.API_CHAT_SOCKET, {
    transports: ['websocket'],
  });

  socket.on('connect', (data) => {
    socket.emit('authen', { token: token, user_id: user_id }, (data) => {
      if (data.result && data.result.auth_data) {
        if (callback) {
          callback(data.result.auth_data.total_unread);
        }
      }
    });
  });

  socket.on('message', (data) => {
    if (data) {
      if (callback) {
        callback(data.total_unread);
      }
    }
  });

  socket.on('read', (data) => {
    if (data) {
      if (callback) {
        callback(data.total_unread);
      }
    }
  });

  socket.on('hb', function (data) {
    socket.emit('hb', null, function (data) {});
  });
}

export function chunkArray(myArray, chunk_size) {
  let results = [];
  while (myArray.length) {
    results.push(myArray.splice(0, chunk_size));
  }
  return results;
}

/**
 * @param {number} bytes - number in bytes
 * @param {number} decimals - decimals
 */
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024,
    dm = decimals < 0 ? 0 : decimals,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Promise.all for an array of promises
 * @param {Array<Promise>} arr
 * @param {Function} callback
 */
export function asyncForEach(arr, callback) {
  return arr.reduce((promise, item, i) => promise.then((_) => callback(item, i)), Promise.resolve());
}

export function randId() {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(2, 10);
}

/**
 * Check if account is a Pro Niaga account
 * @returns {number} StoreID
 */
export function checkIsPN() {
  const cookies = cookie.loadAll();
  if (_has(cookies, 'nuauth_access_token')) {
    const accessToken = cookie.load('nuauth_access_token');
    const decodedToken = jwtDecode(accessToken);
    const storeID = +decodedToken.store_id;

    if (!storeID) {
      redirectToLogin();
    }

    return storeID;
  }
}
